import { render, staticRenderFns } from "./VxCellItemChanceInput.vue?vue&type=template&id=b21bbd8a&scoped=true&"
import script from "./VxCellItemChanceInput.vue?vue&type=script&lang=js&"
export * from "./VxCellItemChanceInput.vue?vue&type=script&lang=js&"
import style0 from "./VxCellItemChanceInput.vue?vue&type=style&index=0&id=b21bbd8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21bbd8a",
  null
  
)

export default component.exports